import React from "react";

const PreparingPapers = () => {
  return (
    <div class="hero mt-20 mb-16">
      <div class="hero-content flex-col lg:flex-row-reverse">
        <img src="https://i.ibb.co/tHCzJGC/Frame-27.png" class="admission" />
        <div>
          <div className="justify-center">
            <h1 class="text-start lg:ml-5 text-5xl font-medium text-primary text-3xl font-italic text-gold-600">
              Preparing papers by
              <span className="text-secondary">
                
                the educational institutions
              </span>
            </h1>

            <p class="mt-8 text-lg text-justify lg:w-9/12 ">
              Alongside advising the right institutions, courses, and countries
              for international students, we also guide on what documentation
              the institutions need for their admission process. Our advisors,
              who provide reliable overseas education consultants in Dhaka and
              Chittagong, assist the applicants in preparing and assembling the
              following documents required during the admission application:
            </p>
            <li className="mt-8 text-lg text-justify lg:w-9/12">
              English Language Proficiency Test Scores (PTE/IELTS)
            </li>
            <li className="text-lg text-justify lg:w-9/12">
              Statement of Purpose (SOP)
            </li>
            <li className="text-lg text-justify lg:w-9/12">
              All-Academic Documents
            </li>
            <li className="text-lg text-justify lg:w-9/12">
             
              Updated Resume/Curriculum Vitae
            </li>
            <li className="text-lg text-justify lg:w-9/12">
              Letters of Recommendation (LOR)
            </li>
            <li className="text-lg text-justify lg:w-9/12">
              Certificates for Extra-curricular Activities
            </li>
            <li className="text-lg text-justify lg:w-9/12">
              Proof of Sufficient Funds
            </li>
            <li className="text-lg text-justify lg:w-9/12">
              Research Proposal & Portfolio
            </li>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreparingPapers;
